import { useEffect, useState } from "react";
import { GetIncentive } from "../../services/incentive";
//import { useNavigate } from "react-router-dom";

const ListIncentive = () => {
    const userid = localStorage.getItem("userid");
    //const navigate = useNavigate();
    const [incentiveData, setIncentiveData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await GetIncentive(userid);
                const data = response.data;
                console.log(data);
                if (response.statusCode === 200 && response.success === true) {
                    setError("");
                    setIncentiveData(data);
                }
                else {
                    setError("something went wrong");
                }
            } catch (error) {

                console.log(error);
                setError(error.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [userid]);
    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Incentive List</h4>
                </div>
                <div>
                    
                </div>
                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                            {/* Total Records */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">
                                    Total Records:
                                    <span className="badge bg-primary ms-2">
                                        {incentiveData.userPercentageDtos.length}
                                    </span>
                                </h5>
                                {/* <button
                                    className="btn btn-success"
                                    onClick={() => navigate("/createplan")}
                                >
                                    + Add New Role
                                </button> */}
                                {/* <span>User Name : {incentiveData.userName}  Amount: {incentiveData.amount}</span> */}
                               <div className="d-flex align-items-center gap-2">
    <span className="badge bg-primary p-2">
        User:    {incentiveData.userName}
    </span>
    <span className="badge bg-success p-2">
        Amount:   ₹{incentiveData.amount}
    </span>
</div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>User Name</th>
                                            <th>Amount</th>
                                            <th>Incentive Amt</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {incentiveData.userPercentageDtos.length > 0 ? (
                                            incentiveData.userPercentageDtos.map((user, index) => (
                                                <tr key={user.username}>
                                                    <td>{index + 1}</td>
                                                    <td>{user.userName}</td>
                                                    <td>
                                                        {user.amount || 0}
                                                    </td>
                                                    <td>
                                                        {user.incentiveAmount || 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    className="text-center"
                                                >
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
export default ListIncentive;